/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "scripts/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 15);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var addWindowOnLoadListener, appendSchemaOrgObjToDom, clearFocus, coatPath, createEllipsis, deleteCookie, findBootstrapEnvironment, findParentElt, getCookie, hasExperimentArms, helpers, humanBootstrapEnvironment, idCounter, isObject, setCookie, track, trackLink, trackPage, trackResize, uniqueId,
  slice = [].slice;

helpers = __webpack_require__(4);

idCounter = 0;

uniqueId = function(prefix) {
  if (prefix == null) {
    prefix = "";
  }
  ++idCounter;
  return "" + prefix + idCounter;
};

findBootstrapEnvironment = function() {
  var el, env, envs, i, len;
  envs = ["lg", "md", "sm", "xs"];
  el = $("<div>&nbsp;</div>");
  el.appendTo($("body"));
  for (i = 0, len = envs.length; i < len; i++) {
    env = envs[i];
    el.addClass("hidden-" + env);
    if (el.is(":hidden")) {
      el.remove();
      return env;
    }
  }
};

humanBootstrapEnvironment = function() {
  var display, screenSize;
  screenSize = findBootstrapEnvironment();
  if (screenSize === "xs") {
    display = "mobile";
  } else if (screenSize === "md" || screenSize === "sm") {
    display = "tablet";
  } else {
    display = "desktop";
  }
  return display;
};

getCookie = function(name) {
  var r;
  r = document.cookie.match("\\b" + name + "=([^;]*)\\b");
  if (r) {
    return r[1];
  } else {
    return void 0;
  }
};

setCookie = function(name, value, days, path, domain) {
  var date, expires;
  expires = '';
  if (days) {
    date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + (date.toGMTString());
  }
  path = path ? "; path=" + path : '';
  domain = domain ? "; domain=" + domain : '';
  return document.cookie = name + "=" + value + expires + path + domain + "; samesite=none; secure";
};

deleteCookie = function(name, path, domain) {
  if (path == null) {
    path = "/";
  }
  return setCookie(name, "", 0, path, domain);
};

findParentElt = function($elt, tagName) {
  while ($elt.prop("tagName") !== tagName) {
    $elt = $elt.parent();
  }
  return $elt;
};

trackPage = function(pageName, title) {
  var pageViewData;
  pageViewData = {
    page: pageName
  };
  if (title) {
    pageViewData.title = title;
  }
  try {
    ga("set", pageViewData);
    return ga('send', 'pageview');
  } catch (error) {}
};

track = function(opts) {
  var cb, cbExists, cbInvoked, gaAction, gaCat, gaLabel, gaOpts, gaSubmit, oskarEvent, oskarOpts, oskarSubmit, submitCb;
  oskarEvent = opts.oskarEvent, oskarOpts = opts.oskarOpts, gaCat = opts.gaCat, gaAction = opts.gaAction, gaLabel = opts.gaLabel, cb = opts.cb;
  if (!gaCat || !gaAction) {
    throw new Error("Google analytics action or category not defined");
  }
  if (!oskarEvent) {
    throw new Error("Oskar event name not defined");
  }
  oskarSubmit = false;
  gaSubmit = false;
  cbInvoked = false;
  cbExists = (opts.cb != null) && typeof opts.cb === "function";
  gaOpts = {
    "hitType": "event",
    "eventCategory": gaCat,
    "eventAction": gaAction,
    "nonInteraction": 1,
    "hitCallback": function() {
      gaSubmit = true;
      return submitCb();
    }
  };
  if ("gaLabel" in opts) {
    gaOpts.eventLabel = gaLabel;
  }
  submitCb = function() {
    if (cbExists && gaSubmit && oskarSubmit && !cbInvoked) {
      cbInvoked = true;
      return cb();
    }
  };
  muse.track(oskarEvent, oskarOpts, (function(_this) {
    return function() {
      oskarSubmit = true;
      return submitCb();
    };
  })(this));
  try {
    ga("send", gaOpts);
  } catch (error) {
    gaSubmit = true;
    submitCb();
  }
  if (cbExists) {
    return setTimeout(function() {
      if (!cbInvoked) {
        cb();
      }
      return cbInvoked = true;
    }, 2000);
  }
};

trackLink = function(e, coatEventName, $target, coatOpts) {
  if (coatOpts == null) {
    coatOpts = {};
  }
  coatOpts.newTab = e.which === 2 || e.which === 3 || e.ctrlKey || e.shiftKey || e.metaKey || $target.target === "_blank" ? true : false;
  if (e.which === 3) {
    coatOpts.rightClick = true;
  }
  if (!coatOpts.newTab) {
    e.preventDefault();
  }
  if (!coatOpts.link) {
    coatOpts.link = $target.getAttribute("href");
  }
  coat.publishSync(coatEventName, coatOpts);
  return true;
};

trackResize = function(eventName) {
  var prevWidth;
  prevWidth = window.museWidth;
  return $(window).on('resize', helpers.throttle(function() {
    var curWidth, isResized;
    curWidth = window.getWidth();
    window.museWidth = curWidth;
    isResized = (curWidth >= muse.consts.MOBILE_WIDTH && prevWidth < muse.consts.MOBILE_WIDTH) || (curWidth < muse.consts.MOBILE_WIDTH && prevWidth >= muse.consts.MOBILE_WIDTH) || (curWidth >= muse.consts.TABLET_WIDTH && prevWidth < muse.consts.TABLET_WIDTH) || (curWidth < muse.consts.TABLET_WIDTH && prevWidth >= muse.consts.TABLET_WIDTH) || (curWidth >= muse.consts.MD_WIDTH && prevWidth > muse.consts.MD_WIDTH) || (curWidth < muse.consts.MD_WIDTH && prevWidth >= muse.consts.MD_WIDTH);
    coat.publishSync(eventName, {
      resized: isResized
    });
    return prevWidth = curWidth;
  }, 400));
};

appendSchemaOrgObjToDom = function(schemaObj) {
  return $("body").append("<script type=\"application/ld+json\"> " + (JSON.stringify(schemaObj)) + " </script>");
};

isObject = function(obj) {
  return obj === Object(obj);
};

addWindowOnLoadListener = function(cb) {
  return window.addEventListener("load", cb);
};

hasExperimentArms = function() {
  var arms, experimentName;
  experimentName = arguments[0], arms = 2 <= arguments.length ? slice.call(arguments, 1) : [];
  return arms.indexOf(muse.experiments[experimentName]) !== -1;
};

createEllipsis = function($el, maxHeight) {
  if ($el.height() > maxHeight) {
    $el.addClass("overflow");
  }
  return $el.css("height", maxHeight + "px");
};

clearFocus = function() {
  if (document.activeElement && document.activeElement !== document.body) {
    return document.activeElement.blur();
  }
};

coatPath = function() {
  return coat.route().split("?")[0];
};

module.exports = {
  uniqueId: uniqueId,
  findBootstrapEnvironment: findBootstrapEnvironment,
  humanBootstrapEnvironment: humanBootstrapEnvironment,
  getCookie: getCookie,
  setCookie: setCookie,
  deleteCookie: deleteCookie,
  findParentElt: findParentElt,
  trackPage: trackPage,
  track: track,
  trackResize: trackResize,
  trackLink: trackLink,
  appendSchemaOrgObjToDom: appendSchemaOrgObjToDom,
  isObject: isObject,
  addWindowOnLoadListener: addWindowOnLoadListener,
  hasExperimentArms: hasExperimentArms,
  createEllipsis: createEllipsis,
  clearFocus: clearFocus,
  coatPath: coatPath
};


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var IndividualModel, MuseModel,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

MuseModel = __webpack_require__(3);

IndividualModel = (function(superClass) {
  extend(IndividualModel, superClass);

  IndividualModel.prototype.model_type = coat.prop(null);

  function IndividualModel(opts) {
    if (!("requestErrorMessage" in opts)) {
      opts.requestErrorMessage = "There was a request error for this model; properties not available";
    }
    IndividualModel.__super__.constructor.call(this, opts);
  }

  IndividualModel.prototype.url = function() {
    return this.baseURL + ("/api/" + (this.model_type()) + "/" + (this.id()));
  };

  IndividualModel.prototype.getTrackProps = function() {
    throw "You can't call get tracks props on an individual model without explicitly defining props.";
  };

  return IndividualModel;

})(MuseModel);

module.exports = IndividualModel;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var CompanyModel, Model,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Model = __webpack_require__(1);

CompanyModel = (function(superClass) {
  extend(CompanyModel, superClass);

  CompanyModel.prototype.model_type = coat.prop("companies");

  function CompanyModel(opts) {
    if (!("iframeType" in opts)) {
      opts.iframeType = null;
    }
    CompanyModel.__super__.constructor.call(this, opts);
  }

  CompanyModel.prototype.getTrackProps = function() {
    if (this.loading()) {
      return {
        company_id: this.id(),
        error_message: "Model still loading; properties not available"
      };
    } else if (this.requestError()) {
      return {
        company_id: this.id(),
        error_message: this.requestErrorMessage()
      };
    } else {
      return {
        company_id: this.id(),
        company_name: this.name(),
        company_short_name: this.short_name(),
        company_favorited: this.favorited(),
        company_industries: this.industries(),
        company_size: this.size_display(),
        company_office_locations: this.location_values(),
        company_ranking_categories: this.ranking_categories(),
        company_tags: this.tags(),
        company_tag_short_names: this.tag_short_names(),
        company_state: this.state(),
        company_twitter: this.twitter(),
        iframe_type: this.iframeType()
      };
    }
  };

  return CompanyModel;

})(Model);

module.exports = CompanyModel;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var MuseModel, util,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

util = __webpack_require__(0);

MuseModel = (function(superClass) {
  extend(MuseModel, superClass);

  MuseModel.prototype.baseURL = "";

  function MuseModel(opts) {
    MuseModel.__super__.constructor.call(this, opts);
    if (typeof muse !== "undefined" && muse !== null ? muse.webHost : void 0) {
      this.baseURL = muse.webHost;
      this.xhrConfig = function(xhr) {
        xhr.withCredentials = true;
        return xhr;
      };
    }
  }

  MuseModel.prototype.xhrConfig = function(xhr) {
    if (!xhr.headers) {
      xhr.headers = {};
    }
    xhr.setRequestHeader("X-Xsrftoken", util.getCookie("_xsrf"));
    return xhr.setRequestHeader("If-Modified-Since", "Sat, 01 Jan 2000 00:00:00 GMT");
  };

  return MuseModel;

})(coat.Model);

module.exports = MuseModel;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

var debounce, throttle,
  slice = [].slice;

throttle = function(fn, number, opts) {
  var args, context, later, previous, result, timeout;
  if (opts == null) {
    opts = {};
  }
  context = args = result = timeout = null;
  previous = 0;
  later = function() {
    if (options.leading === false) {
      previous = 0;
    } else {
      previous = new Date().getTime();
    }
    timeout = null;
    result = fn.apply(context, args);
    if (!timeout) {
      return context = args = null;
    }
  };
  return function() {
    var now, remaining;
    now = new Date().getTime();
    if (!previous && opts.leading === false) {
      previous = now;
    }
    remaining = number - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > number) {
      clearTimeout(timeout);
      timeout = null;
      previous = now;
      result = fn.apply(context, args);
      if (!timeout) {
        context = args = null;
      }
    } else if (!timeout && opts.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
};

debounce = function(fn, threshold, execAsap) {
  var timeout;
  if (threshold == null) {
    threshold = 100;
  }
  timeout = null;
  return function() {
    var args, delayed, obj;
    args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
    obj = this;
    delayed = function() {
      if (!execAsap) {
        fn.apply(obj, args);
      }
      return timeout = null;
    };
    if (timeout) {
      clearTimeout(timeout);
    } else if (execAsap) {
      fn.apply(obj, args);
    }
    return timeout = setTimeout(delayed, threshold);
  };
};

module.exports = {
  throttle: throttle,
  debounce: debounce
};


/***/ }),
/* 5 */
/***/ (function(module, exports) {

var copyObject, genObjFromArray, genObjectUnion;

genObjFromArray = function(values, defaultValue) {
  var i, len, obj, val;
  if (defaultValue == null) {
    defaultValue = 1;
  }
  obj = {};
  for (i = 0, len = values.length; i < len; i++) {
    val = values[i];
    obj[val] = defaultValue;
  }
  return obj;
};

copyObject = function(obj) {
  var key, newObj, val;
  newObj = {};
  for (key in obj) {
    val = obj[key];
    newObj[key] = val;
  }
  return newObj;
};

genObjectUnion = function(objectList) {
  var i, k, len, newObject, object, v;
  newObject = {};
  for (i = 0, len = objectList.length; i < len; i++) {
    object = objectList[i];
    for (k in object) {
      v = object[k];
      newObject[k] = v;
    }
  }
  return newObject;
};

module.exports = {
  genObjFromArray: genObjFromArray,
  copyObject: copyObject,
  genObjectUnion: genObjectUnion
};


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var CompanyIndividualModel, JobIndividualModel, externalTracking, init, loadCompanyTracking, loadJobTracking, objectUtil, storageUtil, trackExternal, trackNakedSuccess, trackVirtualPage, util;

util = __webpack_require__(0);

storageUtil = __webpack_require__(16);

objectUtil = __webpack_require__(5);

JobIndividualModel = __webpack_require__(17);

CompanyIndividualModel = __webpack_require__(2);

externalTracking = __webpack_require__(19);

trackVirtualPage = function(action, model) {
  var virtualPage;
  virtualPage = "/" + (model.type()) + "-job/" + action + "?company_name=" + (model.company_short_name()) + "&job_name=" + (model.short_name());
  return util.trackPage(virtualPage);
};

loadCompanyTracking = function(company_id, eventProps, cb) {
  var companyModel;
  companyModel = new CompanyIndividualModel({
    id: company_id
  });
  return companyModel.get({
    success: function(response, model) {
      eventProps = objectUtil.genObjectUnion([eventProps, model.getTrackProps()]);
      return cb(eventProps);
    },
    error: function(response, model) {
      return cb(eventProps);
    }
  });
};

loadJobTracking = function(job_id, eventProps) {
  var jobModel;
  jobModel = new JobIndividualModel({
    id: job_id
  });
  return jobModel.get({
    success: function(response, model) {
      eventProps = objectUtil.genObjectUnion([eventProps, model.getTrackProps()]);
      trackVirtualPage("success", model);
      return util.track({
        oskarEvent: "Job Apply Success",
        oskarOpts: eventProps,
        gaCat: "ExternalJob",
        gaAction: "Successful"
      });
    }
  });
};

trackNakedSuccess = function(eventProps) {
  eventProps.job_type = "external";
  eventProps.job_application_type = "naked";
  return util.track({
    oskarEvent: "Job Apply Success",
    oskarOpts: eventProps,
    gaCat: "ExternalJob",
    gaAction: "Successful"
  });
};

trackExternal = function(has_visited, company_id, external_job_ids_list, external_job_id, webHost) {
  var eventProps, job_applies, latest_job_id;
  eventProps = {
    script_company_id: company_id,
    script_job_id: external_job_id,
    script_version: company_id ? "company" : "default"
  };
  job_applies = external_job_ids_list != null ? external_job_ids_list[company_id] : void 0;
  if (job_applies != null ? job_applies.length : void 0) {
    eventProps.attribution_confidence = "job_id matches company";
    eventProps.company_job_matches = "True";
    latest_job_id = job_applies.pop();
    loadJobTracking(latest_job_id, eventProps);
    if (latest_job_id === Number(external_job_id)) {
      externalTracking.setExternalJobId(null, metadata.cookie_domain);
    }
    return externalTracking.setExternalJobsList(external_job_ids_list, metadata.cookie_domain);
  } else if (company_id) {
    eventProps.company_job_matches = "False";
    eventProps.attribution_confidence = "only matches company";
    return loadCompanyTracking(company_id, eventProps, trackNakedSuccess);
  } else if (external_job_id) {
    eventProps.company_job_matches = "False";
    eventProps.attribution_confidence = "only matches latest job_id";
    loadJobTracking(external_job_id, eventProps);
    return externalTracking.setExternalJobId(null, metadata.cookie_domain);
  } else if (has_visited) {
    eventProps.attribution_confidence = "no matches";
    return trackNakedSuccess(eventProps);
  }
};

init = function() {
  var external_job_id, external_job_ids_list, ref;
  ref = externalTracking.getStorage(), external_job_ids_list = ref.external_job_ids_list, external_job_id = ref.external_job_id;
  return trackExternal(metadata.has_visited, metadata.company_id, external_job_ids_list, external_job_id, metadata.cookie_domain);
};

init();

module.exports = trackExternal;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var deleteLocalStorage, getLocalStorage, setLocalStorage, util;

util = __webpack_require__(0);

getLocalStorage = function(name) {
  var cookieValue, date, storedItem;
  try {
    storedItem = JSON.parse(localStorage.getItem(name));
  } catch (error) {
    cookieValue = util.getCookie(name);
    storedItem = cookieValue ? JSON.parse(decodeURIComponent(cookieValue)) : void 0;
  }
  if (storedItem != null ? storedItem.expiry : void 0) {
    date = new Date();
    if (date.getTime() >= storedItem.expiry) {
      deleteLocalStorage(name);
      return null;
    }
  }
  return storedItem != null ? storedItem.value : void 0;
};

setLocalStorage = function(name, value, days, cookiefallback) {
  var date, encoded, lsObj, storageObj;
  if (cookiefallback == null) {
    cookiefallback = true;
  }
  lsObj = {
    value: value
  };
  if (days != null) {
    date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    lsObj.expiry = date.getTime();
  }
  storageObj = JSON.stringify(lsObj);
  try {
    localStorage.setItem(name, storageObj);
  } catch (error) {
    if (!cookiefallback) {
      return false;
    }
    encoded = encodeURIComponent(storageObj);
    util.setCookie(name, encoded, days, "/");
  }
  return true;
};

deleteLocalStorage = function(name) {
  try {
    return localStorage.removeItem(name);
  } catch (error) {
    return util.deleteCookie(name);
  }
};

module.exports = {
  getLocalStorage: getLocalStorage,
  setLocalStorage: setLocalStorage,
  deleteLocalStorage: deleteLocalStorage
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var JobModel, Model, getJobProps,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Model = __webpack_require__(1);

getJobProps = __webpack_require__(18);

JobModel = (function(superClass) {
  extend(JobModel, superClass);

  function JobModel() {
    return JobModel.__super__.constructor.apply(this, arguments);
  }

  JobModel.prototype.model_type = coat.prop("jobs");

  JobModel.prototype.getTrackProps = function() {
    if (this.loading()) {
      return {
        job_id: this.id(),
        error_message: "Model still loading; properties not available"
      };
    } else if (this.requestError()) {
      return {
        job_id: this.id(),
        error_message: this.requestErrorMessage()
      };
    } else {
      return getJobProps(this);
    }
  };

  return JobModel;

})(Model);

module.exports = JobModel;


/***/ }),
/* 18 */
/***/ (function(module, exports) {

var getProps;

getProps = function(jobModel) {
  return {
    job_id: jobModel.id(),
    job_name: jobModel.name(),
    job_short_name: jobModel.short_name(),
    job_level: jobModel.level_displays(),
    job_locations: jobModel.location_values(),
    job_categories: jobModel.categories(),
    job_ranking_categories: jobModel.ranking_categories(),
    job_notes_instructions: jobModel.notes_instructions(),
    job_tag_short_names: jobModel.tag_short_names(),
    job_tags: jobModel.tags(),
    job_type: jobModel.type(),
    job_state: jobModel.state(),
    job_applied: jobModel.applied(),
    job_favorited: jobModel.favorited(),
    company_id: jobModel.company_id(),
    company_name: jobModel.company_name(),
    company_short_name: jobModel.company_short_name(),
    job_ats_name: jobModel.ats_name()
  };
};

module.exports = getProps;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var EXTERNAL_JOB_ID_KEY, JOB_APPLY_IDS_LIST_KEY, getStorage, setExternalJobId, setExternalJobsList, util;

util = __webpack_require__(0);

JOB_APPLY_IDS_LIST_KEY = "external_job_ids_list";

EXTERNAL_JOB_ID_KEY = "external_job_id";

getStorage = function() {
  var job_id_list_encoded;
  job_id_list_encoded = util.getCookie(JOB_APPLY_IDS_LIST_KEY);
  return {
    external_job_ids_list: job_id_list_encoded ? JSON.parse(window.atob(job_id_list_encoded)) : {},
    external_job_id: util.getCookie(EXTERNAL_JOB_ID_KEY) || 0
  };
};

setExternalJobsList = function(external_job_ids_list, cookie_domain) {
  var encoded;
  encoded = window.btoa(JSON.stringify(external_job_ids_list));
  return util.setCookie(JOB_APPLY_IDS_LIST_KEY, encoded, 30, "/", cookie_domain);
};

setExternalJobId = function(external_job_id, cookie_domain) {
  if (external_job_id) {
    return util.setCookie(EXTERNAL_JOB_ID_KEY, external_job_id, 30, "/", cookie_domain);
  } else {
    return util.deleteCookie(EXTERNAL_JOB_ID_KEY, "/", cookie_domain);
  }
};

module.exports = {
  getStorage: getStorage,
  setExternalJobsList: setExternalJobsList,
  setExternalJobId: setExternalJobId
};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// frame/successful_apply_frame.cf864bc9797104c9471f.js